// The properties panel's rows, for any record shape.
//
// Nine places in ModelViewer wrote key-colon-value into a template
// literal by hand. That is why a nested object had nine ways to reach
// the screen as "[object Object]" and why fixing one would have left
// eight. The formatting decisions live in helpers/recordFields; this is
// only their markup.
import React from "react";
import { MDBListGroupItem } from "mdbreact";
import { recordFieldRows } from "../../helpers/recordFields";

// A nested field is stepped in from its parent. The panel is narrow and
// already truncates, so the step is small.
const STEP = 14;
const BASE = 12;

export default function RecordFieldRows({ data, omit, idPrefix = "" }) {
  const rows = recordFieldRows(data, { omit });
  return rows.map((r) => {
    // A header row (an object's name) has no value of its own.
    const text = r.text === "" ? `${r.label}:` : `${r.label}: ${r.text}`;
    return (
      <MDBListGroupItem
        key={`${idPrefix}${r.id}`}
        className="border border-light py-1 text-truncate"
        // The row truncates, so the full text has to be reachable
        // somehow; it was not before.
        title={text}
        style={r.depth ? { paddingLeft: BASE + r.depth * STEP } : undefined}
      >
        {text}
      </MDBListGroupItem>
    );
  });
}
